import { ZSpecification } from "./ZSpecification";
import { ZSpecificationCard } from "./ZSpecificationCard";

export const specification2card = ({
  name,
  displayName,
  description,
  definition,
  categoryData,
}: ZSpecification): ZSpecificationCard => ({
  name,
  displayName,
  definition,
  description,
  categoryDataCode: categoryData?.code,
});
